import { forwardRef } from 'react';

import {
  ContainerTitle,
  type ContainerTitleProps,
} from '@frontend/legacy-components';

export type PaneTitleProps = ContainerTitleProps;

export const PaneTitle = forwardRef<HTMLParagraphElement, PaneTitleProps>(
  (props, ref) => (
    <ContainerTitle ref={ref} textTransform="capitalize" {...props} />
  ),
);

PaneTitle.displayName = 'PaneTitle';
